var magicStyles = [".content-scrollable[data-v-e3b9e37a]{max-height:calc(100vh - 500px);overflow:auto}.actions[data-v-e3b9e37a]{margin-top:var(--magic-space--large,32px)}"];

export default magicStyles;
